import React, { useState, useEffect } from 'react';
import { Routes, Route, BrowserRouter, Navigate, useNavigate } from 'react-router-dom';
import { setupAxiosInterceptors } from '../services/network';
import { useSelector } from 'react-redux';
import ScrollToTop from '../components/scroller';
import Layout from '../layout';
import SignIn from '../pages/signin/signin';
import SignUp from '../pages/signup';
import ForgotPassword from '../pages/forgot_password';
import ResetPassword from '../pages/resetpassword';
import SetPassword from '../pages/setpassword';
import Home from '../pages/home';
import Products from '../pages/products';
import PlanProducts from '../pages/products/plan';
import PricingPlan from '../pages/products/pricing';
import Subscriptions from '../pages/subscriptions';
import ProductConfig from '../pages/subscriptions/product_config';
import Summary from '../pages/billing/summary';
import PendingPayments from '../pages/billing/pending_payments';
import ListTransaction from '../pages/billing/list_transaction';
import ChangeCredentials from '../pages/settings/change_credentials';
import Notification from '../pages/settings/notification';
import UserCreation from '../pages/user_creation';
import Unlock from '../pages/unlock';
import NotFound from '../pages/404';
import EditPrint from '../pages/subscriptions/product_config/manage_license/license_details_accordion/editbillpreview/editPrint';

const Router = () => {
    const isAuthenticated = useSelector((state) => state.authReducer.isAuthenticated);
    const [delayedAuth, setDelayedAuth] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDelayedAuth(isAuthenticated);
        }, 3000);

        return () => clearTimeout(timer);
    }, [isAuthenticated]);

    return (
        <BrowserRouter>
            <AppRoutes isAuthenticated={isAuthenticated} delayedAuth={delayedAuth} />
        </BrowserRouter>
    );
};

const AppRoutes = ({ isAuthenticated, delayedAuth }) => {
    const navigate = useNavigate();

    useEffect(() => {
        setupAxiosInterceptors(navigate);
    }, [navigate]);

    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route path='/' element={<SignIn />} />
                <Route path='/signup' element={<SignUp />} />
                <Route path='/forgotpassword' element={<ForgotPassword />} />
                <Route path='/unlock/:token' element={<Unlock />} />
                <Route path='/resetpassword/:token' element={<ResetPassword />} />
                <Route path='/setpassword/:token' element={<SetPassword />} />
                <Route
                    path='/subscriptions/editprint/:side?/:template?'
                    element={
                        isAuthenticated ? (
                            <Layout>
                                <EditPrint />
                            </Layout>
                        ) : (
                            <Navigate to='/' />
                        )
                    }
                />
                <Route
                    path='/home'
                    element={
                        isAuthenticated ? (
                            <Layout>
                                <Home />
                            </Layout>
                        ) : (
                            <Navigate to='/' />
                        )
                    }
                />
                <Route
                    path='/products'
                    element={
                        isAuthenticated ? (
                            <Layout>
                                <Products />
                            </Layout>
                        ) : (
                            <Navigate to='/' />
                        )
                    }
                />
                <Route
                    path='/products/plan'
                    element={
                        isAuthenticated ? (
                            <Layout>
                                <PlanProducts />
                            </Layout>
                        ) : (
                            <Navigate to='/' />
                        )
                    }
                />
                <Route
                    path='/products/pricing'
                    element={
                        isAuthenticated ? (
                            <Layout>
                                <PricingPlan />
                            </Layout>
                        ) : (
                            <Navigate to='/' />
                        )
                    }
                />
                <Route
                    path='/subscriptions'
                    element={
                        isAuthenticated ? (
                            <Layout>
                                <Subscriptions />
                            </Layout>
                        ) : (
                            <Navigate to='/' />
                        )
                    }
                />
                <Route
                    path='/subscriptions/:action/:businessuuid/:productid/:planid/:subscription_uuid/:productPlanDetails/:puser'
                    element={
                        isAuthenticated ? (
                            <Layout>
                                <Subscriptions />
                            </Layout>
                        ) : (
                            <Navigate to='/' />
                        )
                    }
                />
                <Route
                    path='/subscriptions/manageproducts/productconfig/:productid?/:businessuuid'
                    element={
                        delayedAuth ? (
                            <Layout>
                                <ProductConfig />
                            </Layout>
                        ) : (
                            <Navigate to='/' />
                        )
                    }
                />
                <Route
                    path='/summary'
                    element={
                        isAuthenticated ? (
                            <Layout>
                                <Summary />
                            </Layout>
                        ) : (
                            <Navigate to='/' />
                        )
                    }
                />
                <Route
                    path='/pendingpayments'
                    element={
                        isAuthenticated ? (
                            <Layout>
                                <PendingPayments />
                            </Layout>
                        ) : (
                            <Navigate to='/' />
                        )
                    }
                />
                <Route
                    path='/transaction'
                    element={
                        isAuthenticated ? (
                            <Layout>
                                <ListTransaction />
                            </Layout>
                        ) : (
                            <Navigate to='/' />
                        )
                    }
                />
                <Route
                    path='/changecredentails'
                    element={
                        isAuthenticated ? (
                            <Layout>
                                <ChangeCredentials />
                            </Layout>
                        ) : (
                            <Navigate to='/' />
                        )
                    }
                />
                <Route
                    path='/notification'
                    element={
                        isAuthenticated ? (
                            <Layout>
                                <Notification />
                            </Layout>
                        ) : (
                            <Navigate to='/' />
                        )
                    }
                />
                <Route
                    path='/users'
                    element={
                        isAuthenticated ? (
                            <Layout>
                                <UserCreation />
                            </Layout>
                        ) : (
                            <Navigate to='/' />
                        )
                    }
                />

                <Route path='/signin' element={<NotFound />} />
                <Route path='*' element={<NotFound />} />
            </Routes>
        </>
    );
};

export default Router;
